import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ANIMATIONS, ANIMATION } from './models/animations';
import {
	NotificationOptionsModel,
	NotificationOptionType,
	NotificationDefaultIcon,
	NotificationIcon,
	FORMAT_TYPE
} from './models/notification.model';

@Component({
	selector: 'cv-notification',
	styleUrls: ['./notification.component.scss'],
	templateUrl: './notification.component.html',
	animations: [ANIMATION]
})
export class NotificationComponent implements OnInit {
	@Input() type?: string | NotificationOptionType;
	@Input() autoClose?: boolean;
	@Input() animationType?: ANIMATIONS | string;
	@Input() message?: string;
	@Input() displayTime?: 5 | 10 | 20 | 30;
	
	@Input() format?: FORMAT_TYPE = FORMAT_TYPE.PLAIN;
	@Input() options?: NotificationOptionsModel;

	@Output() display: EventEmitter<any> = new EventEmitter<any>();
	@Output() hide: EventEmitter<any> = new EventEmitter<any>();
	@Output() notificationAction: EventEmitter<any> = new EventEmitter<any>();

	fixed = false;
	alertClass: string;
	toastIcon: NotificationIcon;
	size = null;
	milliseconds: number;
	progress = 1;
	show = false;

	animationState: ANIMATIONS | string;
	animation: ANIMATIONS | string;

	private progressInterval;

	constructor() {
		this.alertClass = '';
		// Set the defaults
		this.animationState = `${ANIMATIONS.TOP}-out`;
		this.milliseconds = 5000;
	}

	/**
	 * On init calculate variable values.
	 */
	ngOnInit(): void {
		if (!this.type) {
			this.type = NotificationOptionType.SUCCESS;
		}

		this.alertClass = `alert-${this.type}`;
		if (this.type in NotificationDefaultIcon) {
			this.toastIcon = NotificationDefaultIcon[this.type];
		}

		if (this.displayTime >= 5 && this.displayTime <= 30) {
			this.milliseconds = this.displayTime * 1000;
		}

		if (this.animationType) {
			this.animation = this.animationType;
			this.animationState = `${this.animation}-out`;
		}

		if (this.options && this.options !== null) {
			this.fixed = this.options.fixed || false;

			if ('type' in this.options) {
				this.type = this.options.type;
				this.alertClass = `alert-${this.type}`;

				if (this.type in NotificationDefaultIcon) {
					this.toastIcon = NotificationDefaultIcon[this.type];
				}
			}

			if ('message' in this.options) {
				this.message = this.options.message;
			}

			if ('autoClose' in this.options) {
				this.autoClose = this.options.autoClose;
			}

			if ('displayTime' in this.options) {
				this.milliseconds = this.options.displayTime;
			}

			if ('icon' in this.options) {
				this.toastIcon = this.options.icon;
			}

			if ('size' in this.options) {
				this.size = this.options.size;
			}

			if ('animation' in this.options) {
				const prefix = this.fixed ? 'fixed-' : '';

				this.animation = `${prefix}${this.options.animation}`;
				this.animationState = `${this.animation}-out`;
			}
		}

		setTimeout(() => this.showNotification(), 100);
	}

	/**
	 * Displays the notification and emits the event.
	 */
	showNotification(): void {
		this.animationState = `${this.animation}-in`;
		this.display.emit();
		this.show = true;

		if (this.autoClose) {
			setTimeout(() => this.hideNotification(), this.milliseconds);
			let counter = 0;
			const interval = 100;
			
			this.progressInterval = setInterval(() => {
				this.progress = Math.round((((counter + 1) * interval) * 100) / this.milliseconds);
				counter++;

				if (this.progress >= 100) {
					clearInterval(this.progressInterval);
				}
			}, interval);
		}
	}

	/**
	 * Hides the notification and emits the event.
	 */
	hideNotification(): void {
		if (this.progressInterval) {
			clearInterval(this.progressInterval);
		}
		this.animationState = `${this.animation}-out`;

		setTimeout(() => {
			this.hide.emit();
			this.progress = 0;
			this.show = false;
		}, 800);
	}

	/**
	 * Send event back on close Notification
	 */
	onClickNotification(): void {
		if (this.notificationAction) {
			this.notificationAction.emit();
		}
	}
}
